import { useEffect, useRef } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import CapsuleBox from "UI/CapsuleElement";

const CategoryDropDown = ({
  categoryList,
  selectedCategory,
  setSelectedCategory,
  showCategorySelection,
  setShowCategorySelection,
}) => {
  const categorySelectionRef = useRef();
  const categorySelectionContainerRef = useRef();
  useEffect(() => {
    if (categorySelectionRef.current && showCategorySelection) {
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [showCategorySelection]);

  const handleClickOutside = (event) => {
    if (
      categorySelectionRef?.current &&
      !categorySelectionRef.current?.contains(event.target) &&
      !categorySelectionContainerRef.current?.contains(event.target)
    ) {
      handleCloseCategorySelection();
    }
  };
  const handleCategoryClick = (e) => {
    e.stopPropagation();
    setShowCategorySelection((prev) => !prev);
  };
  const handleCategorySelect = (e, value) => {
    e.stopPropagation();
    setSelectedCategory(value);
    handleCloseCategorySelection();
  };
  const handleCloseCategorySelection = () => {
    setShowCategorySelection(false);
  };
  return (
    <div ref={categorySelectionRef} className="relative flex items-center h-full">
      <CapsuleBox
        parentClass="p-1 items-center gap-2"
        leadingIconContentClass="items-center justify-center w-full py-1 gap-2 rounded-3xl cursor-pointer"
        trailingIcon={
          <div className="rounded-full w-6 h-6 bg-white flex items-center justify-center">
            <ChevronDownIcon className="w-4 mt-[1px]" />
          </div>
        }
        content={<div className=" text-sm font-bold ">{selectedCategory}</div>}
        onCapsuleClick={(e) => handleCategoryClick(e)}
      />
      {showCategorySelection && (
        <div
          ref={categorySelectionContainerRef}
          className="absolute top-7 right-[-8px] flex flex-col justify-center w-full min-w-36 p-1 !z-10 rounded-b-lg bg-white border-grey-border shadow"
        >
          {categoryList?.map((label, index) => {
            return (
              <div
                key={index}
                className={`cursor-pointer items-center w-full p-2 gap-2 text-sm ${
                  label === selectedCategory ? "text-primary" : "text-grey-700"
                }  font-semibold hover:bg-grey-50 hover: rounded`}
                onClick={(e) => handleCategorySelect(e, label)}
              >
                <span className="text-sm">{label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
export default CategoryDropDown;
